// Generated by CoffeeScript 1.12.7
(function () {
  Viewthespace.SpaceDetailPage = (function () {
    function SpaceDetailPage() {
      new Viewthespace.ShadowboxRemoteLink($("#share_space_link"), 573, 700);
      $(".fancybox").fancybox({
        fitToView: false,
        nextEffect: "none",
        prevEffect: "none",
      });
      $(".dot").click(function () {
        var id;
        id = $(this).attr("id").match(/\d+/)[0];
        $(".dot.selected").removeClass("selected");
        $(this).addClass("selected");
        $(".floor-plan-container.active").removeClass("active");
        return $("#floor-plan-" + id).addClass("active");
      });
    }

    return SpaceDetailPage;
  })();
}.call(this));
